var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlock3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 572,
    height: 560,
    viewBox: "0 0 572 560",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_791_28909)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 572,
    height: 560,
    rx: 32,
    fill: "#18181B"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_791_28909)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_791_28909)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 120,
    width: 320,
    height: 320,
    rx: 32,
    fill: "#26272B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 280,
    r: 110,
    fill: "url(#paint0_linear_791_28909)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_791_28909)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 280,
    r: 102,
    fill: "url(#paint1_linear_791_28909)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_791_28909)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 216,
    width: 106,
    height: 128,
    rx: 16,
    fill: "#2C2D32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.5,
    y: 216.5,
    width: 105,
    height: 127,
    rx: 15.5,
    stroke: "url(#paint2_linear_791_28909)",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_di_791_28909)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 233,
    width: 64,
    height: 64,
    rx: 32,
    fill: "url(#paint3_linear_791_28909)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.5,
    y: 231.5,
    width: 67,
    height: 67,
    rx: 33.5,
    stroke: "#333438",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.241 246.539C289.299 245.82 290.701 245.82 291.759 246.539L305.668 255.978C306.502 256.544 307 257.475 307 258.469V271.531C307 272.525 306.502 273.456 305.668 274.022L291.759 283.461C290.701 284.18 289.299 284.18 288.241 283.461L274.332 274.022C273.498 273.456 273 272.525 273 271.531V258.469C273 257.475 273.498 256.544 274.332 255.978L288.241 246.539Z",
    fill: "#24252A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283,
    cy: 258.5,
    r: 2.5,
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 258.5,
    r: 2.5,
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297,
    cy: 258.5,
    r: 2.5,
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283,
    cy: 265.5,
    r: 2.5,
    fill: "#A0A0AB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 265.5,
    r: 2.5,
    fill: "#A0A0AB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297,
    cy: 265.5,
    r: 2.5,
    fill: "#A0A0AB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283,
    cy: 272.5,
    r: 2.5,
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 272.5,
    r: 2.5,
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297,
    cy: 272.5,
    r: 2.5,
    fill: "#3F3F46"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M325 344L325 216",
    stroke: "url(#paint4_linear_791_28909)",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 344L256 216",
    stroke: "url(#paint5_linear_791_28909)",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_791_28909)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 309,
    width: 68,
    height: 18,
    rx: 9,
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_791_28909)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 314,
    width: 42,
    height: 8,
    rx: 4,
    fill: "#51525C"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_di_791_28909)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 243,
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint6_linear_791_28909)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.5,
    y: 241.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "#333438",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_791_28909)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 392,
    cy: 263,
    r: 6.66667,
    stroke: "#FCFCFC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.667 263.333L391 264.667L394.333 261.333",
    stroke: "#FCFCFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_di_791_28909)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 243,
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint7_linear_791_28909)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.5,
    y: 241.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "#333438",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 188,
    cy: 259,
    rx: 2.66667,
    ry: 2.66667,
    stroke: "#FCFCFC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.333 266.667C193.333 268.324 193.333 269.667 188 269.667C182.667 269.667 182.667 268.324 182.667 266.667C182.667 265.01 185.054 263.667 188 263.667C190.945 263.667 193.333 265.01 193.333 266.667Z",
    stroke: "#FCFCFC",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M382 232L363.863 232C361.511 232 359.375 233.375 358.401 235.517L351.599 250.483C350.625 252.625 348.489 254 346.137 254L343 254",
    stroke: "url(#paint8_linear_791_28909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382 300L363.863 300C361.511 300 359.375 298.625 358.401 296.483L351.599 281.517C350.625 279.375 348.489 278 346.137 278L343 278",
    stroke: "url(#paint9_linear_791_28909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 232L216.137 232C218.489 232 220.625 233.375 221.599 235.517L228.401 250.483C229.375 252.625 231.511 254 233.863 254L237 254",
    stroke: "url(#paint10_linear_791_28909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 300L216.137 300C218.489 300 220.625 298.625 221.599 296.483L228.401 281.517C229.375 279.375 231.511 278 233.863 278L237 278",
    stroke: "url(#paint11_linear_791_28909)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 262,
    width: 20,
    height: 2,
    fill: "url(#paint12_linear_791_28909)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 2,
    transform: "matrix(-1 0 0 1 158 262)",
    fill: "url(#paint13_linear_791_28909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.235 357.804C246.364 356.65 247.91 356 249.524 356H332.253C333.997 356 335.655 356.759 336.795 358.08L348.542 371.69C349.483 372.78 350 374.171 350 375.611V440H230V375.826C230 374.258 230.614 372.752 231.711 371.63L245.235 357.804Z",
    fill: "#2C2D32",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.592 358.154C246.627 357.096 248.044 356.5 249.524 356.5H332.253C333.852 356.5 335.372 357.196 336.416 358.406L336.795 358.08L336.416 358.406L348.164 372.017C349.026 373.016 349.5 374.291 349.5 375.611V439.5H230.5V375.826C230.5 374.388 231.063 373.008 232.068 371.98L245.592 358.154Z",
    stroke: "url(#paint14_linear_791_28909)",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.235 202.196C246.364 203.35 247.91 204 249.524 204H332.253C333.997 204 335.655 203.241 336.795 201.92L348.542 188.31C349.483 187.22 350 185.829 350 184.389V120H230V184.174C230 185.742 230.614 187.248 231.711 188.37L245.235 202.196Z",
    fill: "#2C2D32",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.592 201.846C246.627 202.904 248.044 203.5 249.524 203.5H332.253C333.852 203.5 335.372 202.804 336.416 201.594L336.795 201.92L336.416 201.594L348.164 187.983C349.026 186.984 349.5 185.709 349.5 184.389V120.5H230.5V184.174C230.5 185.612 231.063 186.992 232.068 188.02L245.592 201.846Z",
    stroke: "url(#paint15_linear_791_28909)",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324 131L324 149.137C324 151.489 322.625 153.625 320.483 154.599L305.517 161.401C303.375 162.375 302 164.511 302 166.863L302 170",
    stroke: "url(#paint16_linear_791_28909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 131L256 149.137C256 151.489 257.375 153.625 259.517 154.599L274.483 161.401C276.625 162.375 278 164.511 278 166.863L278 170",
    stroke: "url(#paint17_linear_791_28909)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_791_28909)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 161,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#3F3F46"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_791_28909)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 178,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#3F3F46"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.64,
    filter: "url(#filter10_f_791_28909)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 119,
    cy: 119,
    r: 119,
    fill: "#A855F7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_791_28909",
    x: 130,
    y: 120,
    width: 320,
    height: 320,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_791_28909"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.221844 0 0 0 0 0.225529 0 0 0 0 0.240267 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28909"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_791_28909",
    x: 188,
    y: 174,
    width: 204,
    height: 208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28909"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_791_28909",
    x: 221,
    y: 216,
    width: 138,
    height: 160,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_791_28909"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_791_28909",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_di_791_28909",
    x: 243,
    y: 226,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_791_28909"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_791_28909",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_791_28909"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_791_28909",
    x: 257,
    y: 309,
    width: 68,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.535465 0 0 0 0 0.535465 0 0 0 0 0.535465 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28909"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_791_28909",
    x: 270,
    y: 314,
    width: 42,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.535465 0 0 0 0 0.535465 0 0 0 0 0.535465 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28909"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_di_791_28909",
    x: 357,
    y: 236,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_791_28909"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_791_28909",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_791_28909"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_di_791_28909",
    x: 153,
    y: 236,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_791_28909"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_791_28909",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_791_28909"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_791_28909",
    x: 273,
    y: 161,
    width: 34,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.535465 0 0 0 0 0.535465 0 0 0 0 0.535465 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28909"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_791_28909",
    x: 273,
    y: 178,
    width: 34,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.535465 0 0 0 0 0.535465 0 0 0 0 0.535465 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_791_28909"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_791_28909",
    x: -200,
    y: -200,
    width: 638,
    height: 638,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_791_28909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_791_28909",
    x1: 290,
    y1: 170,
    x2: 290,
    y2: 390,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2E32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_791_28909",
    x1: 290,
    y1: 178,
    x2: 290,
    y2: 382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26272B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212225"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_791_28909",
    x1: 237,
    y1: 216,
    x2: 339.5,
    y2: 344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_791_28909",
    x1: 290,
    y1: 233,
    x2: 290,
    y2: 297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53535D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_791_28909",
    x1: 325.5,
    y1: 216,
    x2: 325.5,
    y2: 344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_791_28909",
    x1: 256.5,
    y1: 216,
    x2: 256.5,
    y2: 344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_791_28909",
    x1: 382,
    y1: 245.5,
    x2: 403,
    y2: 283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_791_28909",
    x1: 178,
    y1: 245.5,
    x2: 199,
    y2: 283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_791_28909",
    x1: 382,
    y1: 232,
    x2: 343,
    y2: 255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303134",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_791_28909",
    x1: 382,
    y1: 300,
    x2: 343,
    y2: 277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303134",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_791_28909",
    x1: 198,
    y1: 232,
    x2: 237,
    y2: 255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303134",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_791_28909",
    x1: 198,
    y1: 300,
    x2: 237,
    y2: 277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303134",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_791_28909",
    x1: 422,
    y1: 263,
    x2: 442,
    y2: 263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_791_28909",
    x1: 0,
    y1: 1,
    x2: 20,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_791_28909",
    x1: 230,
    y1: 356,
    x2: 282.652,
    y2: 469.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_791_28909",
    x1: 230,
    y1: 204,
    x2: 282.652,
    y2: 90.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_791_28909",
    x1: 324,
    y1: 131,
    x2: 301,
    y2: 170,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303134",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_791_28909",
    x1: 256,
    y1: 131,
    x2: 279,
    y2: 170,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303134",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474748"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_791_28909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 572,
    height: 560,
    rx: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_791_28909"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 120,
    width: 320,
    height: 320,
    rx: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_791_28909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(384 255)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock3);
export default __webpack_public_path__ + "static/media/block3.0a3a9de8cc35abe0da3fd06966a5ad44.svg";
export { ForwardRef as ReactComponent };